import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=62b3ede2&scoped=true&"
import script from "./goodsList.vue?vue&type=script&lang=js&"
export * from "./goodsList.vue?vue&type=script&lang=js&"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=62b3ede2&lang=less&scoped=true&"
import style1 from "./goodsList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3ede2",
  null
  
)

export default component.exports